export default "__VITE_ASSET__mixQDQw2__"